module.exports = __webpack_public_path__ + "img/diagram.0fae47c1.svg";